import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Tooltip } from "@mui/material";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import moment from "moment";
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import TopBar from "../../Constant/TopBar";
import Footer from "../../Constant/Footer";
import SideBarLeave from "../../Constant/SideBarLeave";
import * as userActions from "../../../actions/index";
import BorderLeaveApprovalModal from '../LeaveModals/BorderLeaveApprovalModal';
import BorderLeaveRejectModal from '../LeaveModals/BorderLeaveRejectModal';
import BorderLeaveApproveModal from '../LeaveModals/BorderLeaveApproveModal';
import ArchiveBorderLeaveModal from '../LeaveModals/ArchiveBorderLeaveModal';
import HostLeaveApproval from '../../../containers/Auth/HostLeaveApproval';
import CapitalFirstLetter from '../../Utility/CapitalFirstLetter';
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import { socket } from '../../../constants/actionTypes';

const customStyles = {
   // option: (provided, state) => ({
   //    ...provided,
   //    "&:hover": {
   //       backgroundColor: state.isFocused ? "#e7f5fe" : "",
   //    },
   //    backgroundColor: state.isSelected ? "#4a8fb8" : "",
   // }),

   option: (provided, state) => ({
      ...provided,
      "&:hover": {
         backgroundColor:
            !state.isSelected && state.isFocused ? "#e7f5fe" : "",
      },
      backgroundColor: state.isSelected ? "#4a8fb8" : "",
   }),
};

const LeaveHistory = (props) => {
   const today = new Date();

   const pastDate = new Date(today);
   pastDate.setDate(today.getDate() - 15);
   const todayStr = pastDate.toISOString().split('T')[0];
   // const todayStr = today.toISOString().split('T')[0];

   const thirtyDaysLater = new Date();
   thirtyDaysLater.setDate(today.getDate() + 15);
   const thirtyDaysLaterStr = thirtyDaysLater.toISOString().split('T')[0];
   const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
   const school_code = user_info?.school_code ?? null;
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [rowVisibility, setRowVisibility] = useState({}); // State for row visibility
   const [page, setPage] = useState(1);
   const [status, setStatus] = useState("")
   const [limit, setLimit] = useState(10);
   const [count, setCount] = useState();
   const [sort, setSort] = useState("departure_date");
   const [order, setOrder] = useState("desc");
   const [search, setSearch] = useState("");
   const [from_date, setFromDate] = useState("");
   const [to_date, setToDate] = useState("");
   // const [from_date, setFromDate] = useState("");
   // const [to_date, setToDate] = useState("");
   const [dormitory_id, setdormitory_id] = useState([]);
   const [dormitory_ids, setdormitory_ids] = useState("");
   const [class_id, setclass_id] = useState([]);
   const [class_ids, setclass_ids] = useState("");
   const [BorderLeaveList, setBorderLeaveList] = useState([]);
   const [userApprovalCounts, setUserApprovalCounts] = useState('');
   const [showModal, setShowModal] = useState("")
   const [approvedBy, setApprovedBy] = useState("")
   const [boarderLeaveData, setBoarderLeaveData] = useState({})
   const [showBoarderLeaveApprovedModal, setShowBoarderLeaveApprovedModal] = useState(false)
   const [showBoarderLeaveRejectModal, setShowBoarderLeaveRejectModal] = useState(false)
   const [filterBySort, setFilterBySort] = useState("created_date")
   const [filterByorder, setFilterByorder] = useState(false)
   const [isLoading, setIsLoading] = useState(false)

   const [showFilters, setShowFilters] = useState(false); // By default filters are hidden

   // Add this function to handle the toggle
   const toggleFilters = () => {
      setShowFilters(!showFilters);
   };
   const [showAccStatus, setShowAccStatus] = useState("")
   const permission_info = JSON.parse(localStorage.getItem("permissions"));
   // If permissions object exists, require approve_reject_boarder_leaves === true to allow approve/reject clicks.
   // If permissions is null (no permissions object), keep existing behaviour (allow clicks as before).
   const hasApproveRejectPermission = permission_info ? !!permission_info.approve_reject_boarder_leaves : null;
   console.log(status, "statusstatusstatusstatus")
   const row_limit = [
      { value: 5, label: 5 },
      { value: 10, label: 10 },
      { value: 15, label: 15 },
      { value: 20, label: 20 },
      { value: 25, label: 25 }
   ]

   const handleToggleRowVisibility = (index) => {
      setRowVisibility((prevState) => ({
         ...prevState,
         [index]: !prevState[index], // Toggle visibility for the specified index
      }));
   };
   // 
   const handleErrorResponse = (response) => {
      try {
         if (response.status === 401) {
            toast.error(response.message, {
               position: toast.POSITION.TOP_CENTER,
            });
            setTimeout(() => {
               navigate('/logout');
            }, 5000);
         } else {
            //  error cases
         }
      }
      catch (e) {
      }
   };

   useEffect(() => {
      GetAllBorderLeavesDetails();
   }, [page, limit, sort, filterByorder, from_date, to_date, class_ids, dormitory_ids, filterBySort, status]);

   useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
         GetAllBorderLeavesDetails();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
      // eslint-disable-next-line
   }, [search]);


   const GetAllBorderLeavesDetails = async () => {
      dispatch(userActions.GetAllBorderLeavesDetails(page, limit, filterBySort, filterByorder, search, from_date, to_date, class_ids, dormitory_ids, status, true)).then((response) => {
         if (response.success === true) {
            setBorderLeaveList(response.data.rows);
            setCount(response.data.count)
            // setUserApprovalCounts(response.user_approval_counts[0])
         }
         else {
            handleErrorResponse(response);
         }
      });
      // eslint-disable-next-line
   };
   const [leaveData, setLeaveData] = useState([]);
   const fetchLeaveData = async () => {
      try {
         const authToken = localStorage.getItem('bss_authtoken');
         const user_info = JSON.parse(localStorage.getItem('bss_authuser'));

         const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${authToken}`,
            country_host: user_info?.country_host,
            school_code: user_info?.school_code,
         };

         const params = {
            from_date: from_date,
            to_date: to_date,
            class_ids: class_ids,
            dormitory_ids: dormitory_ids,
            page: page,
            limit: limit,
            sort: filterBySort,
            order: filterByorder ? 'asc' : 'desc',
            exclude_pending: true,

         };

         const response = await axios.get(
            'https://api.boardingschoolsoftware.com/api/bss-admin/GetBoraderLeavesDashboardStatus',
            { headers, params }
         );

         setLeaveData(response?.data?.data[0]);
      } catch (err) {
         console.error(err);
      } finally {
         // Any cleanup or loading state handling
      }
   };


   useEffect(() => {
      fetchLeaveData();
   }, [from_date, to_date, class_ids, dormitory_ids]);
   useEffect(() => {
      GetAllClassesList();
      GetAllDormitoryStudent();
   }, []);

   const GetAllClassesList = async () => {
      props.onGetAllClassesList().then((response) => {
         if (response.success === true) {
            const arrayData = response.data.rows;
            let state_data = [];
            state_data.push({
               label: "Select Year",
               value: "",
            })
            if (permission_info) {
               const permClassDormArray = permission_info?.perm_class_dorm;
               const filteredPermDorm = permClassDormArray?.filter(item => item?.class_id !== null)
               const allowedDormIds = filteredPermDorm?.map(item => item?.class_id);
               const filteredData = arrayData?.filter(item => allowedDormIds?.includes(item?.class_id));
               for (let key in filteredData) {
                  state_data.push({
                     label: filteredData[key].class_name,
                     value: filteredData[key].class_id,
                     class_id: filteredData[key].class_id,
                  });
               }
            } else {
               for (let key in arrayData) {
                  state_data.push({
                     label: arrayData[key].class_name,
                     value: arrayData[key].class_id,
                     class_id: arrayData[key].class_id,
                  })
               }
            }
            setclass_id(state_data);
         }
      });
   };

   const GetAllDormitoryStudent = async () => {
      props.onGetAllDormitoryStudent(true).then((response) => {
         if (response.success === true) {
            let state_data = [];
            state_data.push({
               label: "Select Dormitory",
               value: "",
            });
            const arrayData = response.data.rows;
            if (permission_info) {
               const permClassDormArray = permission_info?.perm_class_dorm;
               const filteredPermDorm = permClassDormArray.filter(item => item?.dormitory_id !== null)
               const allowedDormIds = filteredPermDorm.map(item => item?.dormitory_id);
               const filteredData = arrayData.filter(item => allowedDormIds.includes(item.dormitory_id));
               for (let key in filteredData) {
                  state_data.push({
                     label: filteredData[key].dormitory_name,
                     value: filteredData[key].dormitory_id,
                     dormitory_id: filteredData[key].dormitory_id,
                  });
               }
            } else {
               for (let key in arrayData) {
                  state_data.push({
                     label: arrayData[key].dormitory_name,
                     value: arrayData[key].dormitory_id,
                     dormitory_id: arrayData[key].dormitory_id,
                  });
               }
            }
            setdormitory_id(state_data);
         } else {
            //notify.show(response.message, "error");
         }
      });
   };



   const ArchiveOrUnarchiveBorderLeave = async (border_leave_id, is_leave_archived) => {
      try {
         const { success, message } = await dispatch(userActions.ArchiveOrUnarchiveBorderLeave({ border_leave_id, is_leave_archived: true }));
         if (success) {
            toast.success(message, {
               position: toast.POSITION.TOP_CENTER,
            });

            navigate(`/${school_code}/leave/boarders-leave-details`)
            GetAllBorderLeavesDetails();
         } else {
            toast.error(message, {
               position: toast.POSITION.TOP_CENTER,
            });
         }
      } catch (error) {

      }
      // eslint-disable-next-line
   };



   const approveBoarderLeave = (leaveData, approvedBy) => {
      setShowModal(true)
      setBoarderLeaveData(leaveData)
      setApprovedBy(approvedBy)
   }

   const hideApprovelLeaveModal = (value) => {
      setShowModal(value)
   };

   const approveAndRejectModal = (approvel) => {
      setShowModal(approvel.value)
      if (approvel.mode === "reject") { setShowBoarderLeaveRejectModal(true) }
      if (approvel.mode === "approve") { setShowBoarderLeaveApprovedModal(true) }
   };

   const hideRejectLeaveModal = (value) => {
      setShowBoarderLeaveRejectModal(value)
   };

   const hideApprovedLeaveModal = (value) => {
      setShowBoarderLeaveApprovedModal(value)
   };

   const BorderLeaveApproval = async (form_data) => {
      setIsLoading(true);
      try {
         const { success, message } = await dispatch(userActions.BorderLeaveApproval(form_data));
         if (success) {
            setIsLoading(false);
            toast.success(message, {
               position: toast.POSITION.TOP_CENTER,
            });
            setShowBoarderLeaveRejectModal(false)
            setShowBoarderLeaveApprovedModal(false)
            GetAllBorderLeavesDetails()
         } else {
            setIsLoading(false);
            toast.error(message, {
               position: toast.POSITION.TOP_CENTER,
            });
         }
      } catch (error) {
         // Handle error if necessary
      }
   };

   // Scroll bar To top functionality
   const [scrollWidth, setScrollWidth] = useState(0);
   const topScrollbarRef = useRef(null);
   const tableContainerRef = useRef(null);
   const scrollbarContentRef = useRef(null);




   useEffect(() => {
      // 
      const topScrollbar = topScrollbarRef.current;
      const tableContainer = tableContainerRef?.current;
      const scrollbarContent = scrollbarContentRef.current;

      if (BorderLeaveList.length > 0) {
         // setScrollWidth(tableContainerRef.current.querySelector(".table").scrollWidth);
         // Set the width of the scrollbar content based on the table container width
         if (scrollbarContent && tableContainer) {
            scrollbarContent.style.width = `${tableContainerRef.current.querySelector(".table").scrollWidth}px`;
         }

         // Sync scroll positions between topScrollbar and tableContainer
         const handleTopScrollbarScroll = () => {
            tableContainer.scrollLeft = topScrollbar.scrollLeft;
         };

         const handleTableContainerScroll = () => {
            topScrollbar.scrollLeft = tableContainer.scrollLeft;
         };

         if (topScrollbar && tableContainer) {
            topScrollbar.addEventListener('scroll', handleTopScrollbarScroll);
            tableContainer.addEventListener('scroll', handleTableContainerScroll);
         }

         // Cleanup event listeners on unmount
         return () => {
            if (topScrollbar && tableContainer) {
               topScrollbar.removeEventListener('scroll', handleTopScrollbarScroll);
               tableContainer.removeEventListener('scroll', handleTableContainerScroll);
            }
         };
      }


   }, [BorderLeaveList]);
   console.log("scrollWidth::", scrollWidth)

   const handleStatusClick = (status) => {
      setStatus(status)
      setPage(1)
   }
   const checkDepartureOverdue = (item) => {
      // Combine departure date and time
      const departureDateTime = moment(`${item.planned_depart_date} ${item.planned_depart_time}`, 'YYYY-MM-DD HH:mm');

      // Get current date and time
      const currentDateTime = moment();

      // Calculate the difference in hours
      const hoursDifference = currentDateTime.diff(departureDateTime, 'hours');

      // Check if departure time is more than 6 hours past AND check_in_out is approved
      return hoursDifference > 6 && item.check_in_out === 'approved';
   };
   const [showWarningModal, setShowWarningModal] = useState(false);

   useEffect(() => {
      const handleBorderLeaveUpdated = (data) => {
         console.log("border-leave-updated event data::", data);
         const leave = data?.leave;
         if (!leave?.border_leave_id) return;

         setBorderLeaveList(prevList =>
            prevList.map(item =>
               String(item.border_leave_id) === String(leave.border_leave_id)
                  ? { ...item, ...leave }
                  : item
            )
         );
      };

      socket.on('border-leave-updated', handleBorderLeaveUpdated);

      return () => {
         socket.off('border-leave-updated', handleBorderLeaveUpdated);
      };
   }, []);

   useEffect(() => {
      const matchesCurrentFilters = (leave) => {
         if (class_ids && leave.class_id !== class_ids) return false;
         if (dormitory_ids && leave.dormitory_id !== dormitory_ids) return false;
         if (status === 'approved' && leave.check_in_out !== 'approved') return false;
         if (status === 'rejected' && leave.check_in_out !== 'rejected') return false;
         if (status === 'pending' && leave.check_in_out !== 'pending') return false;
         return true;
      };

      const handleBorderLeaveAdded = (data) => {
         console.log("border-leave-added event data::", data);
         const leave = data?.leave;
         if (!leave?.border_leave_id || !matchesCurrentFilters(leave)) return;

         setBorderLeaveList(prevList => {
            if (prevList.some(item => String(item.border_leave_id) === String(leave.border_leave_id))) {
               return prevList.map(item =>
                  String(item.border_leave_id) === String(leave.border_leave_id) ? leave : item
               );
            }
            return [leave, ...prevList];
         });
      };

      const handleBorderLeaveRemoved = (data) => {
         console.log("border-leave-removed event data::", data);
         const border_leave_id = data?.border_leave_id;
         if (!border_leave_id) return;

         setBorderLeaveList(prevList =>
            prevList.filter(item => String(item.border_leave_id) !== String(border_leave_id))
         );
      };

      socket.on('border-leave-added', handleBorderLeaveAdded);
      socket.on('border-leave-removed', handleBorderLeaveRemoved);

      return () => {
         socket.off('border-leave-added', handleBorderLeaveAdded);
         socket.off('border-leave-removed', handleBorderLeaveRemoved);
      };
   }, [class_ids, dormitory_ids, status]);

   useEffect(() => {
      const handleBorderLeaveStatsUpdated = (data) => {
         console.log("border-leave-stats-updated event data::", data);
         const stats = data?.stats;
         if (!stats) return;

         setLeaveData(prevData => ({ ...prevData, ...stats }));
      };

      socket.on('border-leave-stats-updated', handleBorderLeaveStatsUpdated);

      return () => {
         socket.off('border-leave-stats-updated', handleBorderLeaveStatsUpdated);
      };
   }, []);

   return (
      <>
         {showModal &&
            <BorderLeaveApprovalModal
               showModal={showModal}
               hideApprovelLeaveModal={(value) => hideApprovelLeaveModal(value)}
               approveAndRejectModal={(approvel) => approveAndRejectModal(approvel)}
               boarderLeaveData={boarderLeaveData}
            />
         }

         {showBoarderLeaveRejectModal &&
            <BorderLeaveRejectModal
               showBoarderLeaveRejectModal={showBoarderLeaveRejectModal}
               hideRejectLeaveModal={(value) => hideRejectLeaveModal(value)}
               boarderLeaveData={boarderLeaveData}
               approvedBy={approvedBy}
               isLoading={isLoading}
               BorderLeaveApproval={(form_data) => BorderLeaveApproval(form_data)}
               fetchLeaveData={fetchLeaveData}
            />
         }
         {showBoarderLeaveApprovedModal &&
            <BorderLeaveApproveModal
               showBoarderLeaveApprovedModal={showBoarderLeaveApprovedModal}
               hideApprovedLeaveModal={(value) => hideApprovedLeaveModal(value)}
               boarderLeaveData={boarderLeaveData}
               approvedBy={approvedBy}
               isLoading={isLoading}
               BorderLeaveApproval={(form_data) => BorderLeaveApproval(form_data)}
               fetchLeaveData={fetchLeaveData}
            />
         }
         {showWarningModal && (
            <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)}>
               <Modal.Header closeButton>
                  <Modal.Title>Action not allowed</Modal.Title>
               </Modal.Header>
               <Modal.Body>
                  Leave approval is not allowed for past dates. Please select a valid leave date to continue.
               </Modal.Body>
               <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowWarningModal(false)}>
                     Close
                  </Button>
               </Modal.Footer>
            </Modal>
         )}
         <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed" >
            <div className="d-flex flex-column flex-root">
               <div className="page d-flex flex-row flex-column-fluid">
                  <SideBarLeave />
                  <div className="wrapper d-flex flex-column flex-row-fluid " id="kt_wrapper">
                     <TopBar />
                     <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                        <div className="post d-flex flex-column-fluid" id="kt_post">
                           <div id="kt_content_container" className="container-fluid">
                              <div className="row">
                                 <div className="col-lg-4" onClick={() => handleStatusClick("")} style={{ cursor: "pointer" }}>
                                    <div className="card bg-light-warning card-xl-stretch ">
                                       <div className="card-body d-flex align-items-center p-5 justify-content-between" >

                                          <p className="card-title text-dark fw-bolder fs-6 d-block mb-0" >Total Applications</p>

                                          <div className="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 ms-4 text-center">
                                             <span className="text-dark fs-1 fw-bolder " >{leaveData.total_leaves}</span>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-lg-4" onClick={() => handleStatusClick("approved")} style={{ cursor: "pointer" }}>
                                    <div className="card bg-light-success card-xl-stretch">
                                       <div className="card-body d-flex align-items-center p-5 justify-content-between" >
                                          <p className="card-title fw-bolder text-dark fs-6 d-block mb-0" >Approved Leave</p>
                                          <div className="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 ms-4 text-center">
                                             <span className="text-dark fs-1 fw-bolder ">{leaveData.total_approved}</span>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-lg-4" onClick={() => handleStatusClick("rejected")} style={{ cursor: "pointer" }}>
                                    <div className="card bg-light-danger card-xl-stretch">
                                       <div className="card-body d-flex align-items-center p-5 justify-content-between"  >
                                          <p className="card-title fw-bolder text-dark fs-6 d-block mb-0" >Rejected Leave</p>
                                          <div className="border border-gray-300 border-dashed rounded min-w-80px py-3 px-4 ms-4 text-center">
                                             <span className="text-dark fs-1 fw-bolder ">{leaveData.total_rejected}</span>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              {showFilters && (
                                 <div className='row mt-5'>
                                    <div className='col-md-12'>
                                       <div className='card'>
                                          <div className='card-header align-items-center'>
                                             <h3 className='card-title'>Student Search</h3>
                                          </div>
                                          <div className='card-body'>

                                             <div className='row align-items-end' >
                                                <div className="col">
                                                   <label className='fw-bold mb-3'>Student Name</label>
                                                   <div className="position-relative">
                                                      <span className="search-icon-block">
                                                         <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                            <path d="M19 19L13.0001 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                         </svg>
                                                      </span>
                                                      <input
                                                         type="search"
                                                         placeholder="Search..."
                                                         className="form-control pe-10"
                                                         value={search}
                                                         onChange={(e) => setSearch(e.target.value)}
                                                      />
                                                   </div>
                                                </div>
                                                <div className="col">
                                                   <label className='form-label'>Select Year</label>
                                                   <Select
                                                      styles={customStyles}
                                                      className="react-bootstrap-typeahead tag-outer select2-selection select2-selection--single " options={class_id}
                                                      value={class_id.filter((option) => {
                                                         return option.value === class_ids;
                                                      })}
                                                      onChange={(event) => {
                                                         setclass_ids(event.value);
                                                      }}
                                                   />
                                                </div>
                                                <div className="col">
                                                   <label className='form-label'>Select Dormitory</label>
                                                   <Select
                                                      styles={customStyles}
                                                      className="react-bootstrap-typeahead tag-outer"
                                                      options={dormitory_id}
                                                      value={dormitory_id.filter((option) => {
                                                         return option.value === dormitory_ids;
                                                      })}
                                                      onChange={(event) => {
                                                         setdormitory_ids(event.value);
                                                      }}
                                                   />
                                                </div>
                                                <div className="col">
                                                   <label className="me-3 form-label">From Date</label>
                                                   <div className='position-relative'>
                                                      <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                         <i class="far fa-calendar-alt"></i>
                                                      </span>
                                                      <input
                                                         id="session-date"
                                                         type="date"
                                                         className="form-control bg-transparent"
                                                         // placeholder='Date'
                                                         value={from_date}
                                                         onChange={(e) => setFromDate(e.target.value)}
                                                         required
                                                      />
                                                   </div>
                                                </div>
                                                <div className="col">
                                                   <label className="ms-3 me-3 form-label">To Date</label>
                                                   <div className='position-relative'>
                                                      <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                         <i class="far fa-calendar-alt"></i>
                                                      </span>
                                                      <input
                                                         id="session-date"
                                                         type="date"
                                                         className="form-control bg-transparent"
                                                         // placeholder='to'
                                                         value={to_date}
                                                         onChange={(e) => setToDate(e.target.value)}
                                                         min={from_date}
                                                         required
                                                      />
                                                   </div>
                                                </div>
                                                <div className='col'>
                                                   <button
                                                      type="reset"
                                                      className="ms-3  btn btn-secondary btn-sm btn-color-gray-700 btn-flex btn-active-primary  border-0 fw-bolder px-4 px-lg-6 me-2 me-lg-3 w-200 white-space"
                                                      onClick={(event) => {
                                                         setclass_ids("");
                                                         setdormitory_ids("");
                                                         setFromDate("");
                                                         setToDate("");
                                                         setSearch("");
                                                      }}
                                                   >
                                                      Clear Search
                                                   </button>
                                                </div>
                                             </div>

                                          </div>
                                       </div>
                                    </div>
                                 </div>)}
                              <div className='row'>
                                 <div className="col-lg-12 mt-5">
                                    <div className='card'>
                                       <div className="card-header align-items-center">
                                          <h3 className="card-title">Approve Leaves Details

                                             <Tooltip className='ms-2'
                                                title={
                                                   <div className="attention-box " style={{ textAlign: 'start' }}>
                                                      <strong className="attention-title">ATTENTION:</strong>{" "}
                                                      <strong>Senior Boarding Staff.</strong> Approval of Leave
                                                      <p style={{ marginBottom: '6px' }}>
                                                         Please be aware that the following message displays prominently on
                                                         the Parent App when they – <strong>“Approve Leave”</strong> for
                                                         their child.
                                                      </p>
                                                      <p>
                                                         “We aim for both Parents/Carers and Hosts to approve a student’s
                                                         leave on this system, it’s the ideal way to keep everyone informed.
                                                         However sometimes, that’s not practical and can hold up a student’s
                                                         plans. On this system, and when needed, Boarding staff can approve
                                                         Leave on behalf of a Parent or Host, following the particular
                                                         school’s guidelines. In every case, Boarding staff are required to
                                                         effect the final Approval or Decline, on this system.”
                                                      </p>
                                                   </div>
                                                }
                                                placement="top"

                                             >
                                                <i className="fas fa-question-circle me-2 pulse-pending" style={{ cursor: 'pointer', color: 'red' }}></i>
                                             </Tooltip></h3>
                                          <div className="d-flex justify-content-end ">
                                             <button
                                                type="button"
                                                className="btn btn-primary btn-lg fw-bolder "
                                                onClick={toggleFilters}
                                                style={{ minWidth: '150px' }}
                                             >
                                                {showFilters ? 'Hide Filters' : 'Show Filters'}
                                                <i className={`fas ${showFilters ? 'fa-chevron-up' : 'fa-filter'} ms-2`}></i>
                                             </button>
                                          </div>
                                       </div>
                                       <div className='card-body'>
                                          <div
                                             className="scrollbar-container"
                                             ref={topScrollbarRef}
                                             style={{
                                                overflowX: 'auto',
                                                height: '20px',
                                                marginBottom: '10px',
                                                // backgroundColor: '#f8f9fa',
                                             }}
                                          >
                                             <div ref={scrollbarContentRef} className="scrollbar-content" style={{ width: '100%', height: '1px' }} />
                                          </div>
                                          <div ref={tableContainerRef} className='table-responsive'>
                                             <MDBTable className='table-row-bordered' style={{ whiteSpace: 'nowrap' }}>
                                                <MDBTableHead>
                                                   <tr style={{ borderBottom: "1x solid #cccccc3d" }}>
                                                      <th></th>
                                                      <th>Unique pin</th>
                                                      <th>Student Name</th>
                                                      <th>Year</th>
                                                      <th>Dormitory</th>
                                                      <th>Student Host</th>
                                                      <th className='min-w-150px'>
                                                         Departure Date
                                                         <i
                                                            className={`bi bi-filter cursor-pointer ${filterBySort === 'departure_date' ? 'text-primary' : ''}`}
                                                            onClick={() => { setFilterBySort('departure_date'); setFilterByorder((prev) => !prev) }}>
                                                         </i>
                                                      </th>
                                                      <th className='min-w-100px'>
                                                         Departure Time
                                                         <i
                                                            className={`bi bi-filter cursor-pointer ${filterBySort === 'departure_time' ? 'text-primary' : ''}`}
                                                            onClick={() => { setFilterBySort('departure_time'); setFilterByorder((prev) => !prev) }}>
                                                         </i>
                                                      </th>
                                                      <th>On Time?</th>
                                                      <th> Parent Approval </th>
                                                      {/* <th> Other Parent Approval </th> */}
                                                      <th>Host Approval</th>
                                                      <th>Manager Approval</th>
                                                      <th>Leave Status</th>
                                                      <th>Actions</th>
                                                   </tr>
                                                </MDBTableHead>
                                                <MDBTableBody>
                                                   {console.log("BorderLeaveList::", BorderLeaveList)}
                                                   {BorderLeaveList?.map((item, index) => {
                                                      const isOverdue = checkDepartureOverdue(item);

                                                      return (
                                                         <React.Fragment key={item.border_leave_id}>
                                                            <tr key={item.border_leave_id}>
                                                               <td>
                                                                  <button
                                                                     className={`btn ${rowVisibility[index]
                                                                        ? ' '
                                                                        : ''
                                                                        } btn-sm w-32px`}
                                                                     type="button"
                                                                     onClick={() => handleToggleRowVisibility(index)}
                                                                  >
                                                                     {
                                                                        rowVisibility[index] ?
                                                                           <img src="/media/downarrow.gif" alt="" style={{ width: "32px", transform: "scaleY(-1)" }} />
                                                                           :
                                                                           <img src="/media/downarrow.gif" alt="" style={{ width: "32px" }} />
                                                                     }
                                                                     {/* <i
                                                                        className={`bi ${rowVisibility[index]
                                                                           ? 'up-arrow'
                                                                           : 'down-arrow'
                                                                           } p-0`}
                                                                     ></i> */}
                                                                  </button>
                                                               </td>
                                                               <td>{item.leave_stu_data?.unique_pin || 'N/A'}</td>
                                                               <td>{CapitalFirstLetter(item.leave_stu_data?.student_name) || 'N/A'}</td>
                                                               <td>{item.boarder_class_data?.class_name || 'N/A'}</td>
                                                               <td>{item.boarder_dorm_data?.dormitory_name || 'N/A'}</td>
                                                               <td>{item.host_id ? item?.stu_host_data?.host_name : item.parent_id && item.parent_type === 'parent1' ? item?.parent_data?.parent1_name : item?.parent_data?.parent2_name || 'N/A'}</td>
                                                               <td>{moment(item.departure_date).format('Do MMM. YYYY')}</td>
                                                               <td>{item.departure_time ? moment(item.departure_time, 'HH:mm:ss').format('hh:mm a') : ''} {isOverdue && <Tooltip title="The student did not utilize the  Leave. Please review and take necessary action." placement="top">

                                                                  <i className="bi bi-flag-fill text-danger ms-2"></i>

                                                               </Tooltip>}
                                                               </td>
                                                               <td>
                                                                  {item.leave_applied_ontime === true ?
                                                                     <Tooltip title="On Time" placement="top">
                                                                        <i className="bi bi-hourglass-split text-success fs-2"></i>
                                                                     </Tooltip>
                                                                     :
                                                                     <Tooltip title="Late" placement="top">
                                                                        <i className="bi bi-hourglass-bottom text-danger fs-2"></i>
                                                                     </Tooltip>
                                                                  }
                                                               </td>
                                                               <td>

                                                                  {item.check_in_out === "cancel" ?
                                                                     <div>
                                                                        <span className="badge badge-light-info me-2">Cancel</span>
                                                                        <Tooltip title="leave canceled due to student not turning up on time" placement="top">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                 <rect x="0" y="0" width="24" height="24" />
                                                                                 <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                              </g>
                                                                           </svg>
                                                                        </Tooltip>
                                                                     </div>
                                                                     : item?.is_parent_approval === "pending" ?
                                                                        <span style={{ width: '75px' }} className="badge me-2 badge-light-warning">
                                                                           pending
                                                                        </span>
                                                                        :
                                                                        <div className="d-flex align-items-center">
                                                                           <Tooltip title={`(${item?.is_parent_approval})${moment(item.last_parent_approval_date).format('Do MMM YYYY')}`} placement="top">
                                                                              <span style={{ width: '75px' }} className={`badge me-2 badge-light-${item?.is_parent_approval === 'approved' ? 'success' : 'danger'}`}>
                                                                                 {item?.is_parent_approval === 'approved' ? 'Approved' : 'Rejected'}
                                                                              </span>
                                                                           </Tooltip>
                                                                           {/* <Tooltip style={{ whiteSpace: 'nowrap' }} title={`${item?.number_matched == true ? "Same IP Detected" : ""}`} placement="top"> */}
                                                                           {
                                                                              item?.number_matched && item?.number_matched === true ?
                                                                                 <img
                                                                                    src="/media/red.png"
                                                                                    style={{ width: "16px", height: '18px', marginRight: '3px' }}
                                                                                 />
                                                                                 : null
                                                                           }
                                                                           {
                                                                              item?.number_matched && item?.number_matched === 'Not Detected' ?
                                                                                 <img
                                                                                    src="/media/black.png"
                                                                                    style={{ width: "16px", height: '18px', marginRight: '3px' }}
                                                                                 />
                                                                                 : null
                                                                           }
                                                                           {/* </Tooltip> */}

                                                                           {(item?.parent_approved_comments || item?.parent_rejected_reason) &&
                                                                              <Tooltip style={{ whiteSpace: 'nowrap' }} title={`${item?.is_parent_approval == 'approved' ? (item.parent_approved_comments ? item.parent_approved_comments : "") : (item?.parent_rejected_reason ? item?.parent_rejected_reason : "")}`} placement="top">


                                                                                 {/* {console.log("item?.number_matched",item?.number_matched)} */}
                                                                                 <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                       <rect x="0" y="0" width="24" height="24" />
                                                                                       <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                       <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                       <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                                    </g>
                                                                                 </svg>
                                                                              </Tooltip>
                                                                           }
                                                                           {/* {item.parent_approval_flag === true ? <div >

                                                                              <Tooltip title="Parent has declined the leave request." placement="top">

                                                                                 <svg width="14px" fill="#f1416c" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z" /></svg>
                                                                              </Tooltip>
                                                                           </div> : ""} */}
                                                                           {item?.parent_approved_by_host === true &&
                                                                              <Tooltip title="This parent status is changed by non primary parent" placement="top">
                                                                                 <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" style={{ marginLeft: '3px' }}>
                                                                                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                       <rect x="0" y="0" width="24" height="24" />
                                                                                       <circle fill="#f6a609" opacity="0.15" cx="12" cy="12" r="10" />
                                                                                       <rect fill="#f6a609" x="11" y="10" width="2" height="7" rx="1" />
                                                                                       <rect fill="#f6a609" x="11" y="7" width="2" height="2" rx="1" />
                                                                                    </g>
                                                                                 </svg>
                                                                              </Tooltip>
                                                                           }
                                                                        </div>

                                                                  }
                                                               </td>

                                                               {/* <td>
                                                                  <span
                                                                     style={{ width: '75px', ...(item?.other_parent_approval === 'approved' || item?.other_parent_approval === 'pending' || item?.other_parent_approval === 'rejected' ? {} : { color: '#A1A5B7' }) }}
                                                                     className={`badge me-2 badge-light-${item?.other_parent_approval === 'approved' ? 'success' : item?.other_parent_approval === 'pending' ? 'warning' : item?.other_parent_approval === 'rejected' ? 'danger' : 'secondary'}`}
                                                                  >
                                                                     {item?.other_parent_approval}
                                                                  </span>
                                                               </td> */}
                                                               <td>

                                                                  {item.check_in_out === "cancel" ? (
                                                                     <div>
                                                                        <span className="badge badge-light-info me-2">Cancel</span>
                                                                        <Tooltip title="leave canceled due to student not turning up on time" placement="top">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                 <rect x="0" y="0" width="24" height="24" />
                                                                                 <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                              </g>
                                                                           </svg>
                                                                        </Tooltip>
                                                                     </div>
                                                                  ) : item?.is_host_approval === "pending" ? (
                                                                     <>
                                                                        <span className="badge me-2 badge-light-warning">
                                                                           pending
                                                                        </span>
                                                                     </>
                                                                  ) : (
                                                                     <div className='d-flex'>
                                                                        <Tooltip title={`(${item?.is_host_approval})${moment(item.last_host_approval_date).format('Do MMM YYYY')}`} placement="top">
                                                                           <span className={`badge me-2 badge-light-${item?.is_host_approval === 'approved' ? 'success' : 'danger'}`}>
                                                                              {item?.is_host_approval === 'approved' ? 'Approved' : 'Rejected'}
                                                                           </span>
                                                                        </Tooltip>
                                                                        {(item?.host_approved_comments || item?.host_rejected_comments) &&
                                                                           <Tooltip title={`${item?.is_host_approval == 'approved' ? (item.host_approved_comments === null ? "leave approved" : item.host_approved_comments) : item.host_rejected_comments}`} placement="top">
                                                                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                    <rect x="0" y="0" width="24" height="24" />
                                                                                    <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                    <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                    <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                                 </g>
                                                                              </svg>
                                                                           </Tooltip>
                                                                        }
                                                                        {/* {item.host_approval_flag === true ? <div >

                                                                           <Tooltip title="Host has declined the leave request." placement="top">

                                                                              <svg width="14px" fill="#f1416c" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 64 0 368 0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 64.3-16.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L64 48l0-16z" /></svg>
                                                                           </Tooltip>
                                                                        </div> : ""} */}
                                                                     </div>
                                                                  )}
                                                               </td>
                                                               {/* host */}
                                                               <td>
                                                                  {item.check_in_out === "cancel" ?
                                                                     <div>
                                                                        <span className="badge badge-light-info me-2">Cancel</span>
                                                                        <Tooltip title="leave canceled due to student not turning up on time" placement="top">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                 <rect x="0" y="0" width="24" height="24" />
                                                                                 <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                 <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                              </g>
                                                                           </svg>
                                                                        </Tooltip>
                                                                     </div>
                                                                     :
                                                                     item?.is_user_approval === "pending" ?
                                                                        <>
                                                                           <Tooltip title={hasApproveRejectPermission === false ? "You don't have access" : ""} placement="top">
                                                                              <span
                                                                                 style={{ width: '75px' }}
                                                                                 className={`badge me-2 badge-light-warning ${hasApproveRejectPermission === false ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'}`}
                                                                                 onClick={(e) => {
                                                                                    if (hasApproveRejectPermission === false) return;
                                                                                    approveBoarderLeave(item, "user");
                                                                                 }}
                                                                                 aria-disabled={hasApproveRejectPermission === false}
                                                                              >
                                                                                 pending
                                                                              </span>
                                                                           </Tooltip>

                                                                           {item?.leave_stu_data?.grounded_data?.is_grounded_activate === true ?
                                                                              <Tooltip title="Grounded Student" placement="top">
                                                                                 <svg width="20" height="20" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M4 2v20h2v-8h10l-2-4 2-4H6V2H4z" />
                                                                                 </svg>

                                                                              </Tooltip>
                                                                              : null
                                                                           }
                                                                        </>
                                                                        :
                                                                        <div className='d-flex'>
                                                                           <Tooltip title={`(${item?.is_user_approval})${moment(item.last_user_approval_date).format('Do MMM YYYY')}`} placement="top">
                                                                              <span
                                                                                 style={{ width: '75px' }}
                                                                                 className={`badge me-2 badge-light-${item?.is_user_approval === 'approved' ? 'success' : 'danger'}`}
                                                                              >
                                                                                 {item?.is_user_approval === 'approved' ? 'Approved' : 'Rejected'}
                                                                              </span>
                                                                           </Tooltip>
                                                                           {(item?.user_approved_comments || item?.user_rejected_reason_data?.reject_reason) &&
                                                                           <Tooltip title={`${item?.is_user_approval == 'approved' ? item.user_approved_comments : item.user_rejected_reason_data?.reject_reason}`} placement="top">
                                                                              <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                                                 <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                                    <rect x="0" y="0" width="24" height="24" />
                                                                                    <circle fill="#000000" opacity="0.1" cx="12" cy="12" r="10" />
                                                                                    <rect fill="#4a8fb8 " x="11" y="10" width="2" height="7" rx="1" />
                                                                                    <rect fill="#4a8fb8 " x="11" y="7" width="2" height="2" rx="1" />
                                                                                 </g>
                                                                              </svg>
                                                                           </Tooltip>
                                                                           }
                                                                        </div>
                                                                  }
                                                               </td>
                                                               {/* host */}
                                                               <td>
                                                                  {((item?.host_approval_flag == true || item?.parent_approval_flag == true) && item.check_in_out == "out") && <Tooltip
                                                                     title={`${item?.leave_stu_data?.student_name} has Signed Out but - since then - ${item?.host_approval_flag === true && item?.parent_approval_flag === false
                                                                        ? 'Host has rejected the Leave'
                                                                        : item?.parent_approval_flag === true && item?.host_approval_flag === false
                                                                           ? 'Parent has rejected the Leave'
                                                                           : item?.host_approval_flag === true && item?.parent_approval_flag === true
                                                                              ? 'Both Host and Parent have rejected the Leave'
                                                                              : 'Leave status is unclear'
                                                                        }. It is strongly suggested Senior Boarding Staff is notified immediately and situation addressed. This may mean getting student back on campus at earliest opportunity.`}
                                                                     placement="top"
                                                                  >
                                                                     {/* <i className="bi bi-exclamation-triangle text-danger ms-2"></i> */}
                                                                     <i className="bi bi-info-square text-danger ms-2"></i>
                                                                  </Tooltip>
                                                                  }
                                                                  <span className={`badge me-2 badge-light-${item.check_in_out === 'in' || item.check_in_out === 'approved' ? 'success' : item.check_in_out === 'out' ? "danger" : item.check_in_out === 'pending' ? "warning" : "info"}`}>
                                                                     {item.check_in_out}

                                                                  </span>


                                                               </td>
                                                               <td>
                                                                  <Tooltip title="View" placement="top">
                                                                     <Link to={`/${school_code}/leave/edit-boarders-leave/${item.border_leave_id}`}>
                                                                        <i className="bi bi-eye-fill text-primary fs-2"></i>
                                                                     </Link>
                                                                  </Tooltip>
                                                               </td>
                                                            </tr>
                                                            {rowVisibility[index] && (
                                                               <>
                                                                  <tr className='text-bg-light'>
                                                                     <th></th>
                                                                     <th colSpan={2}>Return Date</th>
                                                                     <th colSpan={2}>Return Time</th>
                                                                     <th colSpan={2}>Mode Of Travel Departure</th>
                                                                     <th colSpan={2}>Mode Of Travel Return</th>
                                                                     <th colSpan={3}>Submit Date</th>
                                                                     <th colSpan={2}>Submit Time</th>
                                                                     {/* <th>Action</th> */}
                                                                  </tr>
                                                                  <tr className='text-bg-light'>
                                                                     <td></td>
                                                                     <td colSpan={2}>{moment(item.return_date).format('Do MMM. YYYY')}</td>
                                                                     <td colSpan={2}>{item.return_time ? moment(item.return_time, 'HH:mm:ss').format('hh:mm a') : ''}</td>
                                                                     <td colSpan={2}>{item.departure_mode_data?.travel_mode_name}</td>
                                                                     <td colSpan={2}>{item.return_mode_data?.travel_mode_name}</td>
                                                                     <td colSpan={3}>{moment(item.created_date).format('Do MMM. YYYY')}</td>
                                                                     <td colSpan={2}>{moment(item.created_date).format('hh:mm a')}</td>
                                                                     {/* <td>
                                                                        <ArchiveBorderLeaveModal ArchiveOrUnarchiveBorderLeave={() => {
                                                                           ArchiveOrUnarchiveBorderLeave(item.border_leave_id, item.is_leave_archived);
                                                                        }} />
                                                                     </td> */}
                                                                  </tr>
                                                               </>
                                                            )}
                                                         </React.Fragment>
                                                      )
                                                   })}
                                                </MDBTableBody>
                                             </MDBTable>
                                          </div>
                                          <div className="d-flex justify-content-between">
                                             <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                defaultValue={row_limit[1]}
                                                name="color"
                                                options={row_limit}
                                                onChange={(e) => setLimit(e.value)}
                                             />
                                             <Stack>
                                                <Pagination
                                                   count={Math.ceil(count / limit)}
                                                   page={page}
                                                   onChange={(e, value) => setPage(value)}
                                                   color="primary"
                                                />
                                             </Stack>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        {/* <HostLeaveApproval/> */}
                     </div>
                     <Footer />
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
   onGetAllDormitoryStudent: userActions.GetAllDormitoryStudent,
   onGetAllClassesList: userActions.GetAllClassesList,
};
export default connect(mapStateToProps, mapDispatchToProps)(LeaveHistory);

